export default "__VITE_ASSET__q6WvnL_n__"